var wrappers = require('./dist-modules/higher-order.js');
exports.root = wrappers.root;
exports.branch = wrappers.branch;



//////////////////
// WEBPACK FOOTER
// ./~/baobab-react/higher-order.js
// module id = 3
// module chunks = 0